<template>
	<div class="container">
		<card-erp />
	</div>
</template>

<script>
import CardErp from './components/card-erp.vue'

export default {
	components: {
		CardErp,
	},
}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
